import { render } from "./MiEspacioPanel.vue?vue&type=template&id=736abefa&scoped=true"
import script from "./MiEspacioPanel.vue?vue&type=script&lang=js"
export * from "./MiEspacioPanel.vue?vue&type=script&lang=js"

import "./MiEspacioPanel.vue?vue&type=style&index=0&id=736abefa&scoped=true&lang=css"
import "./MiEspacioPanel.vue?vue&type=style&index=1&id=736abefa&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736abefa"]])

export default __exports__